export default function useIsObjectEmpty(obj: Record<string, unknown>): boolean {
  if (obj instanceof Object) {
    return Object.keys(obj).length === 0
  } else if (Array.isArray(obj)) {
    console.error('Not an Object')
  }
  return false
}
